export const computeFuelTypeURL = ({ key }) => {
    const keyword = key.toLowerCase().split(" ").join("-");
    return [keyword, "cars"];
};
